import React from 'react';

import { LoadingSpinner } from '@/components/LoadingSpinner';
import { AddDeviceContainer } from '@/features/mfa/components/MfaDevices/AddDeviceContainer';
import MfaErrorPage from '@/features/mfa/components/MfaErrorPage';
import MfaVerifyForm from '@/features/mfa/components/MfaVerifyForm';
import {
  selectIsMfaSkipped,
  selectShouldShowAddDevice,
  selectShouldShowMfaErrorPage,
  selectShouldShowOtp
} from '@/features/mfa/selectors';

import { useSelector } from 'react-redux';

const MfaContainer = () => {
  const isLoading = useSelector((state) => state.mfa.isLoading);
  const isAddDevice = useSelector(selectShouldShowAddDevice);
  const isVerifyForm = useSelector(selectShouldShowOtp);
  const isSkipped = useSelector(selectIsMfaSkipped);
  const isMfaError = useSelector(selectShouldShowMfaErrorPage);

  if (isLoading) {
    return <LoadingSpinner title={'Loading MFA...'} />;
  }
  if (isMfaError) {
    return <MfaErrorPage />;
  }
  if (isSkipped) {
    return null;
  }
  if (isAddDevice) {
    return <AddDeviceContainer />;
  }
  if (isVerifyForm) {
    return <MfaVerifyForm />;
  }
  return null;
};

export default MfaContainer;
